import type { PropertyPaymentInfo } from '../types'

export function isPropertyPaymentVerified(info: PropertyPaymentInfo | null | undefined): boolean {
  const verifyValue = String(info?.verify ?? '').trim().toUpperCase()
  return ['1', 'YES', 'TRUE', 'VERIFIED'].includes(verifyValue)
}
